export default __webpack_public_path__ + "static/media/LOGO-TOP20-BIG.eb3737e7.svg";